import { useState } from "react";
import bloenm from '../images/bloenm.jpg';
import dreeef from '../images/dreeef.jpg';
import dreef2 from '../images/dreef2.jpg';
import koetjesweide from '../images/koetjesweide.jpg';
import roos from '../images/roos.jpg';
import sterkekoe from '../images/sterkekoe.jpg';
// import struik from '../images/struik.jpg';
import tractor from '../images/tractor.jpg';
import tractor2 from '../images/tractor2.jpg';
import wilg from '../images/wilg.jpg';
import vlees from '../images/vlees.jpg';
import kalf from '../images/kalf.jpg';
import VersneldToog from "../images/VersneldToog.mp4";
import { Helmet } from "react-helmet"

const fotos = [
    { id: 13, name: 'Toog', imageSrc: VersneldToog, imageAlt: "Video van de toog in de slagerij", isVideo: true },
    { id: 1, name: 'bloenm', imageSrc: bloenm, imageAlt: "Bloemen op de hoeve" },
    { id: 2, name: 'dreeef', imageSrc: dreeef, imageAlt: "Dreef pad met bomen" },
    { id: 3, name: 'dreef2', imageSrc: dreef2, imageAlt: "Dreef in de zomer" },
    { id: 4, name: 'koetjesweide', imageSrc: koetjesweide, imageAlt: "Koeien in de weide" },
    { id: 5, name: 'roos', imageSrc: roos, imageAlt: "Roos in de tuin" },
    { id: 6, name: 'sterkekoe', imageSrc: sterkekoe, imageAlt: "Koe in het veld" },
    // { id: 7, name: 'struik', imageSrc: struik, imageAlt: "struik" },
    { id: 8, name: 'tractor', imageSrc: tractor, imageAlt: "Tractor op de hoeve" },
    { id: 9, name: 'tractor2', imageSrc: tractor2, imageAlt: "Tractor met hooi op de hoeve" },
    { id: 10, name: 'wilg', imageSrc: wilg, imageAlt: "Wilg in de tuin" },
    { id: 11, name: 'vlees', imageSrc: vlees, imageAlt: "Stukken vlees" },
    { id: 12, name: 'kalf', imageSrc: kalf, imageAlt: "Kalf in de stal" },    
];

export default function Fotos() {
    const [selectedMedia, setSelectedMedia] = useState(null);

    return (
        <>
        <Helmet>
            <title>Foto's | Hoeveslagerij De Spycker</title>
            <meta name="description" content="Bekijk de foto's van op onze hoeve en in de slagerij." />
            <link rel="canonical" href="https://www.hoeveslagerijdespycker.be/foto's" />
        </Helmet>
        <div className="bg-gray-100 mt-10">
            <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-8">
                <h2 className="text-2xl font-bold tracking-tight text-red-900">Foto's</h2>

                <div className="mt-6 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
                    {fotos.map((foto) => (
                        <div key={foto.id} className="group relative">
                            {foto.isVideo ? (
                                <video
                                    src={foto.imageSrc}
                                    className="aspect-square w-full rounded-md bg-gray-200 object-cover cursor-pointer group-hover:opacity-75 lg:aspect-auto lg:h-80"
                                    onClick={() => setSelectedMedia(foto)}
                                    muted
                                    loop
                                    autoPlay
                                />
                            ) : (
                                <img
                                    alt={foto.imageAlt}
                                    src={foto.imageSrc}
                                    className="aspect-square w-full rounded-md bg-gray-200 object-cover cursor-pointer group-hover:opacity-75 lg:aspect-auto lg:h-80"
                                    onClick={() => setSelectedMedia(foto)}
                                />
                            )}
                        </div>
                    ))}
                </div>
            </div>

            {/* Modal voor vergroting van afbeelding of video */}
            {selectedMedia && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50"
                    onClick={() => setSelectedMedia(null)} // Sluit bij klikken buiten de media
                >
                    <div className="relative max-w-4xl mx-auto p-4">
                        <button 
                            className="absolute top-4 m-4 right-4 text-red-900 bg-white rounded-full p-2 shadow-lg"
                            onClick={() => setSelectedMedia(null)}
                        >
                            ✕
                        </button>
                        {selectedMedia.isVideo ? (
                            <video 
                                src={selectedMedia.imageSrc} 
                                controls 
                                className="max-h-[80vh] max-w-full rounded-lg shadow-lg"
                            />
                        ) : (
                            <img 
                                src={selectedMedia.imageSrc} 
                                alt="Vergrote afbeelding" 
                                className="max-h-[80vh] max-w-full rounded-lg shadow-lg"
                            />
                        )}
                    </div>
                </div>
            )}
        </div>
        </>
    );
}
